import React, { useState, useEffect } from "react";
import { sidebarApi } from "../../services/api/sidebarApi";
import useLinkedInStickySidebar from "../../hooks/useLinkedInStickySidebar";
import OnlineFriendsWidget from "./widgets/OnlineFriendsWidget";
import PeopleSuggestionsWidget from "./widgets/PeopleSuggestionsWidget";
import TrendingTopicsWidget from "./widgets/TrendingTopicsWidget";
import UserStatsWidget from "./widgets/UserStatsWidget";
import CollaborationOpportunitiesWidget from "./widgets/CollaborationOpportunitiesWidget";
import UnansweredQuestions from "./widgets/UnansweredQuestions";
import BountyQuestions from "./widgets/BountyQuestions";
import "./FeedSidebar.css";

const FeedSidebar = () => {
  const [widgets, setWidgets] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const sidebarRef = useLinkedInStickySidebar({ topOffset: 16, bottomOffset: 16 });

  useEffect(() => {
    loadWidgets();

    // Refresh widgets every 5 minutes
    const interval = setInterval(loadWidgets, 5 * 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  const loadWidgets = async () => {
    try {
      setError(null);
      const response = await sidebarApi.getAllWidgets({
        includeOnlineFriends: true,
        includeSuggestions: true,
        includeTrendingTopics: true,
        includeStats: true,
        includeCollaborationOpportunities: true,
        onlineFriendsLimit: 5,
        suggestionsLimit: 15,
        trendingLimit: 5,
        collaborationLimit: 3,
      });

      setWidgets(response.data.data);
    } catch (error) {
      setError("Failed to load sidebar");
      setWidgets({
        onlineFriends: [],
        suggestions: [],
        trendingTopics: [],
        userStats: null,
        collaborationOpportunities: [],
      });
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <aside className="cbx-feed-sidebar" ref={sidebarRef}>
        <div className="cbx-widget-skeleton" />
        <div className="cbx-widget-skeleton" />
        <div className="cbx-widget-skeleton" />
      </aside>
    );
  }

  return (
    <aside
      className="cbx-feed-sidebar"
      ref={sidebarRef}
    >
      {/* Show error message if failed to load */}
      {error && (
        <div className="cbx-sidebar-error">
          <p>{error}</p>
          <button onClick={loadWidgets} className="cbx-retry-btn-small">
            Retry
          </button>
        </div>
      )}

      {/* User Stats */}
      {widgets?.userStats && (
        <UserStatsWidget stats={widgets.userStats} />
      )}

      {/* Online Friends */}
      <OnlineFriendsWidget friends={widgets?.onlineFriends || []} />

      {/* People You May Know */}
      <PeopleSuggestionsWidget suggestions={widgets?.suggestions || []} />

      {/* Trending Topics */}
      <TrendingTopicsWidget topics={widgets?.trendingTopics || []} />

      {/* Collaboration Opportunities */}
      {widgets?.collaborationOpportunities && (
        <CollaborationOpportunitiesWidget
          opportunities={widgets.collaborationOpportunities}
        />
      )}

      {/* Unanswered Questions */}
      <UnansweredQuestions />

      {/* Bounty Questions */}
      <BountyQuestions />
    </aside>
  );
};

export default FeedSidebar;
